export default "__VITE_ASSET__DYb5OGyz__"